
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/licitatii",
      function () {
        return require("private-next-pages/licitatii.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/licitatii"])
      });
    }
  